module.exports = __webpack_public_path__ + "../resources/img/ic_re_server_notification_glass_img.c666d64f.svg";